import { RouteConfig } from 'vue-router';
import Breadcrumbs from './breadcrumbs';

const FAQs = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "FAQs" */ '@/views/FAQs/faqs');
const PortalServices = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "PortalServices" */ '@/views/EServices/eServices');
const ServiceDetails = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "ServiceDetails" */ '@/views/ServiceDetails/serviceDetails');
const ContactUs = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "ContactUs" */ '@/views/ContactUs/contactUs');
const SmartSearchResult = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "ContactUs" */ '@/views/SmartSearchResult/smartSearchResult');

const routes = [
  {
    path: '/e-services',
    name: 'PortalServices',
    component: PortalServices,
    meta: {
      highlighted: true,
      breadcrumb: Breadcrumbs.portalServices,
      eventName: 'portal-services',
      eventNameAr: 'خدمات البوابة',
      eventNameEn: 'portal services',
    },
  },
  {
    path: '/e-services/:serviceId',
    name: 'ServiceDetails',
    component: ServiceDetails,
    meta: {
      highlighted: true,
      breadcrumb: Breadcrumbs.serviceDetails,
      eventName: 'ServiceDetails',
      eventNameAr: 'تفاصيل الخدمات',
      eventNameEn: 'ServiceDetails',

    },
  },
  {
    path: '/faq',
    name: 'faq',
    component: FAQs,
    meta: {
      highlighted: true,
      breadcrumb: Breadcrumbs.faq,
      eventName: 'faq',
      eventNameAr: 'الأسئلة الشائعة',
      eventNameEn: 'faq',

    },
  },
  {
    path: '/contact-us',
    name: 'ContactUs',
    component: ContactUs,
    meta: {
      highlighted: true,
      breadcrumb: Breadcrumbs.contactUs,
      eventName: 'contact-us',
      eventNameAr: 'اتصل بنا',
      eventNameEn: 'contact-us',
    },
  },
  {
    path: '/search/:searchText',
    name: 'smart-search-result',
    component: SmartSearchResult,
    meta: {
      highlighted: true,
      breadcrumb: Breadcrumbs.searchResult,
      eventName: 'search-result',
      eventNameAr: 'نتائج البحث',
      eventNameEn: 'search result',
    },
  },
] as RouteConfig[];

export default routes;
